import {Inject, Injectable} from '@angular/core';
import {BackendService, BackendServiceError} from './backend.service';
import {DataService} from './data.service';
import {PaymentMethodType} from './models/payment.models';
import {APP_SETTINGS} from './settings-data.provider';
import {Settings} from './models/models';
import { HttpErrorResponse } from '@angular/common/http';


export class PaymentApiError extends Error {
  error?: Error;

  constructor(error: Error) {
    super();
    this.error = error;
    this.name = 'PaymentApiError';
  }

}

@Injectable({ providedIn: 'root' })
export class PosApiPaymentService {

  constructor(@Inject(APP_SETTINGS) private readonly settings: Settings, private readonly dataService: DataService,
              private readonly backendService: BackendService) {
  }


  async callPayment(): Promise<boolean> {
    const paymentMethod = this.settings.paymentMethods.find(({ gateway }) => gateway === 'versa_commerce_pos_zvt');

    if (!paymentMethod) {
      throw new Error('No zvt payment defined in current settings');
    }
    try {
      const result = await this.backendService.callPaymentAuthorization(this.settings.posUuid, {
        amount: this.dataService.cart.totalPrice,
        payment_method_id: paymentMethod.gateway,
      });
      await this.dataService.updateCartAttributes({
        attributes: {
          zvt_payment_transaction_id: result.transactionId
        }
      });
      await this.dataService.checkoutCart({
        method: PaymentMethodType.creditCard,
        cardType: 'cc', // FIXME: ???
        paymentMethod,
      });
      return true;
    } catch (error: any) {
      if (error instanceof BackendServiceError) {
        if (error.wrapped instanceof HttpErrorResponse) {
          throw new PaymentApiError(error.wrapped);
        }
        else {
          throw error;
        }
      }
      throw new PaymentApiError(error);
    }
  }

  async callRefund(transactionId: string, amount: number): Promise<boolean> {
    const paymentMethod = this.settings.paymentMethods.find(({ gateway }) => gateway === 'versa_commerce_pos_zvt');

    if (!paymentMethod) {
      throw new Error('No zvt payment defined in current settings');
    }
    try {
      const result = await this.backendService.callRefund(this.settings.posUuid, {
        amount: amount,
        payment_method_id: paymentMethod.gateway,
        transaction_id: transactionId
      });
      await this.dataService.updateCartAttributes({
        attributes: {
          zvt_refund_transaction_id: result.transactionId
        }
      });
      return true;
    } catch (error: any) {
      if (error instanceof BackendServiceError) {
        if (error.wrapped instanceof HttpErrorResponse) {
          throw new PaymentApiError(error.wrapped);
        }
        else {
          throw error;
        }
      }
      throw new PaymentApiError(error);
    }

  }

  async callReversal(transactionId: string): Promise<boolean> {
    const paymentMethod = this.settings.paymentMethods.find(({ gateway }) => gateway === 'versa_commerce_pos_zvt');

    if (!paymentMethod) {
      throw new Error('No zvt payment defined in current settings');
    }
    try {
      const result = await this.backendService.callReversal(this.settings.posUuid, {
        transaction_id: transactionId,
        payment_method_id: paymentMethod.gateway,
      });
      await this.dataService.updateCartAttributes({
        attributes: {
          zvt_reversal_transaction_id: result.transactionId
        }
      });
      return true;
    } catch (error: any) {
      if (error instanceof BackendServiceError) {
        if (error.wrapped instanceof HttpErrorResponse) {
          throw new PaymentApiError(error.wrapped);
        }
        else {
          throw error;
        }
      }
      throw new PaymentApiError(error);
    }
  }

  async callClosePeriod(): Promise<boolean> {
    const paymentMethod = this.settings.paymentMethods.find(({ gateway }) => gateway === 'versa_commerce_pos_zvt');

    if (!paymentMethod) {
      throw new Error('No zvt payment defined in current settings');
    }
    try {
      const result = await this.backendService.callEndOfDay(this.settings.posUuid, {
        payment_method_id: paymentMethod.gateway,
      });
      await this.dataService.updateCartAttributes({
        attributes: {
          zvt_end_of_day_transaction_id: result.transactionId
        }
      });
      return true;
    } catch (error: any) {
      if (error instanceof BackendServiceError) {
        if (error.wrapped instanceof HttpErrorResponse) {
          throw new PaymentApiError(error.wrapped);
        }
        else {
          throw error;
        }
      }
      throw new PaymentApiError(error);
    }
  }
}
